module.exports = __webpack_public_path__ + "img/dog-placeholder.2548959a.svg";